import type { FragmentType } from '@/gql/codegen';
import type React from 'react';
import {
  SelectUserEnrollmentPage,
  type USER_ENROLLMENT_LIST_ITEM,
} from '../-Page';

export type SelectUserEnrollmentContainerProps = {
  selectableEmbaUserEnrollments: FragmentType<
    typeof USER_ENROLLMENT_LIST_ITEM
  >[];
  selectUserEnrollment: (embaUserEnrollmentId: string) => Promise<void>;
};

export const SelectUserEnrollmentContainer = ({
  selectableEmbaUserEnrollments,
  selectUserEnrollment,
}: SelectUserEnrollmentContainerProps) => {
  return (
    <SelectUserEnrollmentPage
      selectableEmbaUserEnrollments={selectableEmbaUserEnrollments}
      selectUserEnrollment={selectUserEnrollment}
    />
  );
};
